import React, { PropsWithChildren, useState } from 'react';
import { DataSourceRasterLayer } from '../../../types/types';


const Store = React.createContext<{
  rasterLayers: DataSourceRasterLayer[],
  removeLayer: (name: string) => void,
  addLayer: (layer: DataSourceRasterLayer) => void,
  clearLayers: () => void
}>({
  rasterLayers: [],
  removeLayer: (name: string) => {},
  addLayer: (layer: DataSourceRasterLayer) => {},
  clearLayers: () => {}
});

export const useLayerStore = () => React.useContext(Store);

type LayerProviderProps = {};

const LayerProvider = ({ children }: PropsWithChildren<LayerProviderProps>) => {
  const [rasterLayers, setRasterLayers] = useState<DataSourceRasterLayer[]>([]);

  const addLayer = (layer: DataSourceRasterLayer) => {
    setRasterLayers(oldArray => [...oldArray, layer]);
  }

  const removeLayer = (name: string) => {
    setRasterLayers(rasterLayers.filter(layer => layer.name !== name))
  }

  const clearLayers = () => {
    setRasterLayers([])
  }

  return (
    <Store.Provider value={{ rasterLayers, addLayer, removeLayer, clearLayers }}>{children}</Store.Provider>
  );
};

export default LayerProvider;
